export const moduleSlug = "QUOTA_MANAGER";

export default { moduleSlug };
